/**
 * Inveterate subscriber gift — reads config from `#inveterate-subscriber-gift-root` (Liquid).
 */
(function () {
  function readBool(el, key) {
    return el.dataset[key] === 'true';
  }

  var root = document.getElementById('inveterate-subscriber-gift-root');
  if (!root) return;

  var vidRaw = (root.dataset.variantId || '').trim();
  var VARIANT_ID = vidRaw ? Number(vidRaw) : NaN;
  var COOKIE_NAME = root.dataset.cookieName || 'inveterate_subscriber_gift';
  var SUPPRESSED = root.dataset.cookieSuppressedValue || 'suppressed';
  var PROP_KEY = root.dataset.propertyKey || '_inveterate_subscriber_gift';
  var ENABLED_GIFT_SETTING = readBool(root, 'enabled');
  var SUBSCRIBER_ELIGIBLE = readBool(root, 'subscriberEligible');
  var lastVariantQty = null;
  var skipRemovalDetect = false;
  var skipAutoAddUntilInteraction = false;
  var reconcileTimer = null;
  /** Aborts stale `cart.js` GET when a newer `reconcile` run starts (read coalescing). */
  var reconcileCartReadAbort = null;

  var inveterateGiftLineLoadingRef = 0;
  var inveterateSlotAddingRef = 0;
  var CART_UPDATED_WAIT_MS = 12000;

  var fetchJsonHeaders = {
    Accept: 'application/json',
    'X-Requested-With': 'xmlhttprequest',
  };

  var postJsonHeaders = {
    'Content-Type': 'application/json',
    'X-Requested-With': 'xmlhttprequest',
  };

  /** @param {AbortSignal} [signal] */
  function fetchCartJson(signal) {
    var init = { headers: fetchJsonHeaders };
    if (signal) init.signal = signal;
    return fetch(window.Shopify.routes.root + 'cart.js', init).then(function (r) {
      return r.json();
    });
  }

  function postCartJson(url, body) {
    return fetch(window.Shopify.routes.root + url, {
      method: 'POST',
      headers: postJsonHeaders,
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  function applyInveterateGiftLinesLoading(show) {
    document.querySelectorAll('[data-inveterate-subscriber-gift]').forEach(function (row) {
      if (row.classList.contains('cart__drawer-item')) row.classList.toggle('cart__drawer-item--loading', show);
      if (row.classList.contains('cart-table__item')) row.classList.toggle('cart-table__item--loading', show);
      if (show) row.setAttribute('aria-busy', 'true');
      else row.removeAttribute('aria-busy');

      var btn = row.querySelector('[data-inveterate-gift-remove]');
      if (btn) {
        btn.disabled = show;
        var idle = btn.querySelector('[data-inveterate-remove-idle]');
        var busy = btn.querySelector('[data-inveterate-remove-busy]');
        if (idle && busy) {
          idle.classList.toggle('hidden', show);
          busy.classList.toggle('hidden', !show);
        }
      }
    });
  }

  function beginInveterateGiftLineMutation() {
    inveterateGiftLineLoadingRef++;
    if (inveterateGiftLineLoadingRef === 1) applyInveterateGiftLinesLoading(true);
  }

  function endInveterateGiftLineMutation() {
    if (inveterateGiftLineLoadingRef <= 0) return;
    inveterateGiftLineLoadingRef--;
    if (inveterateGiftLineLoadingRef === 0) applyInveterateGiftLinesLoading(false);
  }

  function applyInveterateGiftSlotAdding(show) {
    var slot = document.getElementById('inveterate-subscriber-gift-slot');
    if (!slot) return;
    var btn = slot.querySelector('[data-inveterate-add-gift]');
    if (!btn) return;
    btn.disabled = show;
    var idle = btn.querySelector('[data-inveterate-slot-idle]');
    var busy = btn.querySelector('[data-inveterate-slot-busy]');
    if (idle && busy) {
      idle.classList.toggle('hidden', show);
      busy.classList.toggle('hidden', !show);
    }
  }

  function beginInveterateSlotAdding() {
    inveterateSlotAddingRef++;
    if (inveterateSlotAddingRef === 1) applyInveterateGiftSlotAdding(true);
  }

  function endInveterateSlotAdding() {
    if (inveterateSlotAddingRef <= 0) return;
    inveterateSlotAddingRef--;
    if (inveterateSlotAddingRef === 0) applyInveterateGiftSlotAdding(false);
  }

  function attachInveterateGiftLineMutationEndGuards() {
    var ended = false;
    function finish() {
      if (ended) return;
      ended = true;
      window.removeEventListener('cart:updated', onCartUpdated);
      clearTimeout(timer);
      endInveterateGiftLineMutation();
    }
    function onCartUpdated() {
      finish();
    }
    var timer = setTimeout(finish, CART_UPDATED_WAIT_MS);
    window.addEventListener('cart:updated', onCartUpdated);
  }

  function waitForCartUpdatedOrTimeout(ms) {
    ms = ms || CART_UPDATED_WAIT_MS;
    return new Promise(function (resolve) {
      function done() {
        window.removeEventListener('cart:updated', done);
        clearTimeout(tid);
        resolve();
      }
      window.addEventListener('cart:updated', done);
      var tid = setTimeout(done, ms);
    });
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setSuppressedCookie() {
    var maxAgeDays = 180;
    var attrs = [
      COOKIE_NAME + '=' + encodeURIComponent(SUPPRESSED),
      'path=/',
      'SameSite=Lax',
      'Max-Age=' + (maxAgeDays * 24 * 60 * 60),
    ];
    if (location.protocol === 'https:') attrs.push('Secure');
    document.cookie = attrs.join('; ');
  }

  function deleteCookie(name) {
    document.cookie = name + '=; path=/; Max-Age=0; SameSite=Lax';
  }

  function inveterateGiftEligible() {
    return ENABLED_GIFT_SETTING && SUBSCRIBER_ELIGIBLE && vidRaw !== '' && !Number.isNaN(VARIANT_ID);
  }

  function clearSuppressCookieIfIneligible() {
    if (!inveterateGiftEligible()) deleteCookie(COOKIE_NAME);
  }

  function isSuppressed() {
    return getCookie(COOKIE_NAME) === SUPPRESSED;
  }

  function cartLineHasGiftMark(item) {
    if (!item) return false;
    var props = item.properties;
    if (props == null) return false;
    if (Array.isArray(props)) {
      for (var ia = 0; ia < props.length; ia++) {
        var p = props[ia];
        var k = p && (p.name != null ? String(p.name) : p.first != null ? String(p.first) : '');
        var v = p && (p.value != null ? p.value : p.last);
        if (k === PROP_KEY && v != null && String(v) !== '') return true;
      }
      return false;
    }
    if (typeof props !== 'object') return false;
    var val = props[PROP_KEY];
    return val != null && String(val) !== '';
  }

  /**
   * One pass over cart lines — variant qty for configured gift SKU, managed-line flag,
   * and “every line is gift-marked”.
   */
  function analyzeCartGiftState(cart) {
    var empty = { variantQty: 0, hasManagedLine: false, onlyManagedGiftLines: false };
    if (!cart || !cart.items || !cart.items.length) return empty;

    var items = cart.items;
    var variantQty = 0;
    var hasManagedLine = false;
    var onlyManagedGiftLines = true;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (cartLineHasGiftMark(item)) hasManagedLine = true;
      else onlyManagedGiftLines = false;
      if (vidRaw !== '' && String(item.variant_id) === vidRaw) {
        variantQty += Number(item.quantity) || 0;
      }
    }
    return {
      variantQty: variantQty,
      hasManagedLine: hasManagedLine,
      onlyManagedGiftLines: onlyManagedGiftLines,
    };
  }

  function variantQtyInCart(cart) {
    return analyzeCartGiftState(cart).variantQty;
  }

  function usableCartPayload(data) {
    return data && Array.isArray(data.items) ? data : null;
  }

  function resolveCartAfterUpdateResponse(data) {
    var u = usableCartPayload(data);
    if (u) return Promise.resolve(u);
    return fetchCartJson();
  }

  function syncSlotConcealClass(slot, hasManagedLine) {
    if (!slot || !inveterateGiftEligible()) return;
    if (hasManagedLine) slot.classList.add('hidden');
  }

  function updateUiVisibility(snapshotCart) {
    if (!inveterateGiftEligible()) return;
    var slot = document.getElementById('inveterate-subscriber-gift-slot');
    if (!slot) return;

    function hideSlot() {
      slot.classList.add('hidden');
    }
    function showSlot() {
      slot.classList.remove('hidden');
    }

    function applyFromCart(cart) {
      var s = analyzeCartGiftState(cart);
      syncSlotConcealClass(slot, s.hasManagedLine);
      var sup = isSuppressed();
      var present = s.hasManagedLine || (vidRaw !== '' && s.variantQty > 0);
      var hasOtherLines = Number(cart.item_count) > 0;
      if (sup && !present && hasOtherLines) showSlot();
      else hideSlot();
    }

    if (snapshotCart && snapshotCart.items) {
      applyFromCart(snapshotCart);
      return;
    }

    fetchCartJson()
      .then(applyFromCart)
      .catch(function () {
        hideSlot();
      });
  }

  function clampVariantToOne(cart) {
    var total = variantQtyInCart(cart);
    if (total <= 1 || Number.isNaN(VARIANT_ID)) return Promise.resolve(cart);

    var lines = cart.items.filter(function (item) {
      return String(item.variant_id) === vidRaw;
    });
    if (!lines.length) return Promise.resolve(cart);

    lines.sort(function (a, b) {
      var aGift = cartLineHasGiftMark(a) ? 1 : 0;
      var bGift = cartLineHasGiftMark(b) ? 1 : 0;
      return bGift - aGift;
    });

    var keepKey = lines[0].key;
    var updates = {};
    cart.items.forEach(function (item) {
      if (String(item.variant_id) === vidRaw) {
        updates[item.key] = item.key === keepKey ? 1 : 0;
      }
    });

    beginInveterateGiftLineMutation();
    skipRemovalDetect = true;
    return postCartJson('cart/update.js', { updates: updates, sections: 'cart-drawer,cart-main' })
      .then(function (data) {
        if (window.updateCartContents) window.updateCartContents(data);
        if (window.refreshCart) window.refreshCart();
        return resolveCartAfterUpdateResponse(data).then(function (fresh) {
          return waitForCartUpdatedOrTimeout().then(function () {
            return fresh;
          });
        });
      })
      .finally(function () {
        endInveterateGiftLineMutation();
        skipRemovalDetect = false;
      });
  }

  function removeManagedGiftLines(cart, skipSectionsRefresh) {
    if (!cart || !cart.items) return Promise.resolve();
    var updates = {};
    cart.items.forEach(function (it) {
      if (cartLineHasGiftMark(it)) updates[it.key] = 0;
    });
    if (Object.keys(updates).length === 0) return Promise.resolve();

    beginInveterateGiftLineMutation();
    skipRemovalDetect = true;
    var body = { updates: updates };
    if (!skipSectionsRefresh) body.sections = 'cart-drawer,cart-main';
    return postCartJson('cart/update.js', body)
      .then(function (data) {
        if (!skipSectionsRefresh && window.updateCartContents) window.updateCartContents(data);
        if (!skipSectionsRefresh && window.refreshCart) window.refreshCart();
        if (!skipSectionsRefresh) {
          return waitForCartUpdatedOrTimeout().then(function () {
            return data;
          });
        }
        return data;
      })
      .finally(function () {
        endInveterateGiftLineMutation();
        skipRemovalDetect = false;
      });
  }

  function addGiftLine() {
    if (Number.isNaN(VARIANT_ID)) return Promise.resolve();
    beginInveterateSlotAdding();
    skipRemovalDetect = true;
    if (typeof window.setCheckoutButtonLoading === 'function') window.setCheckoutButtonLoading();
    var props = {};
    props[PROP_KEY] = '1';
    return postCartJson('cart/add.js', {
      items: [{ id: VARIANT_ID, quantity: 1, properties: props }],
      sections: 'cart-drawer,cart-main',
    })
      .then(function (data) {
        var errored = !!(data.status && Number(data.status) >= 400) || !!(data.errors && Object.keys(data.errors).length);
        if (data.description && !data.sections) {
          console.warn('Inveterate gift add:', data.description);
          errored = true;
        }
        if (errored) skipAutoAddUntilInteraction = true;
        if (!errored && window.updateCartContents) window.updateCartContents(data);
        if (!errored && window.refreshCart) window.refreshCart();
        if (!errored) {
          return waitForCartUpdatedOrTimeout().then(function () {
            return data;
          });
        }

        return data;
      })
      .finally(function () {
        endInveterateSlotAdding();
        skipRemovalDetect = false;
        if (typeof window.resetCheckoutButtonUi === 'function') window.resetCheckoutButtonUi();
      });
  }

  window.inveterateSubscriberGiftSuppressAndRemove = function (lineKey) {
    beginInveterateGiftLineMutation();
    attachInveterateGiftLineMutationEndGuards();
    setSuppressedCookie();
    if (typeof window.cartItemUpdate === 'function') window.cartItemUpdate(lineKey, 0);
  };

  var reconcileTail = Promise.resolve();

  function reconcile(cartHint) {
    reconcileTail = reconcileTail
      .then(function () {
        if (typeof AbortController !== 'undefined') {
          if (reconcileCartReadAbort) reconcileCartReadAbort.abort();
        }

        if (cartHint && Array.isArray(cartHint.items)) {
          reconcileCartReadAbort = null;
          return Promise.resolve(cartHint);
        }

        if (typeof AbortController !== 'undefined') {
          reconcileCartReadAbort = new AbortController();
        }
        var readSignal =
          reconcileCartReadAbort &&
          reconcileCartReadAbort.signal;

        return fetchCartJson(readSignal).then(
          function (payload) {
            reconcileCartReadAbort = null;
            return payload;
          },
          function (err) {
            reconcileCartReadAbort = null;
            throw err;
          }
        );
      })
      .then(function (cart) {
        if (!inveterateGiftEligible()) {
          deleteCookie(COOKIE_NAME);
          skipAutoAddUntilInteraction = false;
          lastVariantQty = null;
          var sIn = analyzeCartGiftState(cart);
          if (sIn.hasManagedLine) {
            return removeManagedGiftLines(cart, false).then(function () {});
          }
          lastVariantQty = sIn.variantQty;
          return cart;
        }

        var s = analyzeCartGiftState(cart);
        var qty = s.variantQty;

        if (s.onlyManagedGiftLines) {
          if (typeof window.setCheckoutButtonLoading === 'function') window.setCheckoutButtonLoading();
          return removeManagedGiftLines(cart, false)
            .then(resolveCartAfterUpdateResponse)
            .then(function (fresh) {
              lastVariantQty = analyzeCartGiftState(fresh).variantQty;
              updateUiVisibility(fresh);
              return fresh;
            })
            .finally(function () {
              if (typeof window.resetCheckoutButtonUi === 'function') window.resetCheckoutButtonUi();
            });
        }

        var prev = lastVariantQty;

        if (
          prev !== null &&
          !skipRemovalDetect &&
          prev > 0 &&
          qty === 0 &&
          !isSuppressed() &&
          Number(cart.item_count) > 0
        ) {
          setSuppressedCookie();
          lastVariantQty = 0;
          updateUiVisibility(cart);
          return cart;
        }

        updateUiVisibility(cart);

        if (isSuppressed()) {
          lastVariantQty = qty;
          if (qty > 1) return clampVariantToOne(cart);
          return cart;
        }

        if (qty > 1) {
          return clampVariantToOne(cart).then(function (c2) {
            lastVariantQty = analyzeCartGiftState(c2 || cart).variantQty;
          });
        }

        if (qty === 0 && !skipAutoAddUntilInteraction && Number(cart.item_count) > 0) {
          return addGiftLine().then(function () {
            var wc = window.cart;
            if (wc && Array.isArray(wc.items)) {
              lastVariantQty = analyzeCartGiftState(wc).variantQty;
              return wc;
            }
            return fetchCartJson().then(function (c3) {
              lastVariantQty = analyzeCartGiftState(c3).variantQty;
              return c3;
            });
          });
        }

        lastVariantQty = qty;
        return cart;
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
      });

    return reconcileTail;
  }

  var reconcilePendingMode = null;

  function scheduleReconcile(cartFromEvent) {
    if (cartFromEvent != null && Array.isArray(cartFromEvent.items)) {
      reconcilePendingMode = { type: 'CART', cart: cartFromEvent };
    } else {
      reconcilePendingMode = 'FETCH';
    }

    clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(function () {
      reconcileTimer = null;
      var mode = reconcilePendingMode;
      reconcilePendingMode = null;
      if (mode && mode.type === 'CART') {
        reconcile(mode.cart);
      } else {
        reconcile();
      }
    }, 0);
  }

  function initInveterateSubscriberGiftListeners() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest && ev.target.closest('[data-inveterate-add-gift]');
      if (!btn || !inveterateGiftEligible()) return;
      if (!document.getElementById('inveterate-subscriber-gift-slot')) return;
      if (!btn.closest || !btn.closest('#inveterate-subscriber-gift-slot')) return;
      ev.preventDefault();
      deleteCookie(COOKIE_NAME);
      skipAutoAddUntilInteraction = false;
      lastVariantQty = null;
      updateUiVisibility();
      addGiftLine().then(function () {
        var wrap = document.querySelector('.cart__drawer-wrap');
        if (wrap && !wrap.classList.contains('active') && window.showCart) window.showCart();
      });
    });

    window.addEventListener('cart:updated', function (ev) {
      if (inveterateGiftLineLoadingRef > 0) applyInveterateGiftLinesLoading(true);
      if (inveterateSlotAddingRef > 0) applyInveterateGiftSlotAdding(true);
      var c = ev.detail && ev.detail.cart;
      if (c && c.items) updateUiVisibility(c);
      scheduleReconcile(c);
    });
    window.addEventListener('cart:added', function () {
      scheduleReconcile();
    });
    window.addEventListener('cart:drawer-opened', function () {
      scheduleReconcile();
    });
  }

  function boot() {
    clearSuppressCookieIfIneligible();
    initInveterateSubscriberGiftListeners();
    lastVariantQty = null;
    reconcile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();